import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';
import { AuthFacade } from '../../auth/services/auth.facade';

@Injectable({
	providedIn: 'root',
})
export class NonAuthenticatedGuard {
	constructor(
		private authFacade: AuthFacade,
		private router: Router
	) {}

	canLoad(route: Route, segments: UrlSegment[]): boolean {
		return this.check();
	}

	private check(): boolean {
		const isTokenExpired = this.authFacade.isAccessTokenExpired();

		if (!isTokenExpired) {
			this.router.navigate(['/']);

			return false;
		}

		return true;
	}
}
